


import { Product, User, UserRole, Order, OrderStatus, StoreStock, StockTransaction, TransactionType, TransactionStatus } from '../types';

export const INITIAL_USERS: User[] = [
  { id: 'u1', name: 'Sarah Super', role: UserRole.SUPER_ADMIN, email: 'super@wolfdrivers.com', password: '123456', requiresPasswordReset: false },
  { id: 'u2', name: 'Adam Admin', role: UserRole.ADMIN, email: 'admin@wolfdrivers.com', password: '123456', requiresPasswordReset: false },
  { id: 'u3', name: 'Dave Dispatch', role: UserRole.DISPATCH, email: 'dispatch@wolfdrivers.com', password: '123456', requiresPasswordReset: false },
  { id: 'u4', name: 'Dan Driver', role: UserRole.STORE, email: 'dan@wolfdrivers.com', password: '123456', requiresPasswordReset: false },
  { id: 'u5', name: 'Edna Driver', role: UserRole.STORE, email: 'edna@wolfdrivers.com', password: '123456', requiresPasswordReset: false },
];

export const INITIAL_PRODUCTS: Product[] = [
  { id: 'p1', name: 'Premium Water 5L', category: 'Beverages', price: 5.00, warehouseStock: 500 },
  { id: 'p2', name: 'Snack Box Mix', category: 'Food', price: 12.50, warehouseStock: 200 },
  { id: 'p3', name: 'Coffee Beans 1kg', category: 'Beverages', price: 25.00, warehouseStock: 100 },
  { id: 'p4', name: 'Paper Cups (50pk)', category: 'Supplies', price: 3.00, warehouseStock: 1000 },
];

export const INITIAL_DRIVER_STOCK: StoreStock[] = [
  { storeId: 'u4', productId: 'p1', quantity: 10 },
  { storeId: 'u4', productId: 'p2', quantity: 5 },
];

// --- Historical Dates for Scenarios (2023) ---
// Using numeric constructor (Year, Month Index 0-11, Day, Hour, Min) to ensure Local Time consistency
const DATE_NOV_16_START = new Date(2023, 10, 16, 8, 0, 0).getTime(); // Nov 16, 8:00 AM
const DATE_NOV_16_DELIVERY_1 = new Date(2023, 10, 16, 10, 30, 0).getTime();
const DATE_NOV_16_DELIVERY_2 = new Date(2023, 10, 16, 14, 15, 0).getTime();
const DATE_NOV_16_END = new Date(2023, 10, 16, 17, 30, 0).getTime();

const DATE_NOV_17_START = new Date(2023, 10, 17, 8, 15, 0).getTime(); // Nov 17, 8:15 AM
const DATE_NOV_17_DELIVERY_1 = new Date(2023, 10, 17, 11, 0, 0).getTime();
const DATE_NOV_17_DELIVERY_2 = new Date(2023, 10, 17, 13, 45, 0).getTime();
const DATE_NOV_17_END = new Date(2023, 10, 17, 18, 0, 0).getTime();

export const INITIAL_ORDERS: Order[] = [
  // --- Active / Recent Orders ---
  {
    id: 'o1',
    orderNumber: 'ORD-9281',
    customerName: 'Alice Johnson',
    address: '123 Maple St',
    items: [{ productId: 'p1', quantity: 2 }],
    status: OrderStatus.DELIVERED,
    storeId: 'u4',
    requiresCash: true,
    cashAmount: 10.00,
    requiresETransfer: false,
    eTransferAmount: 0,
    requirePhoto: true,
    createdAt: Date.now() - 86400000,
    deliveredAt: Date.now() - 4000000,
  },
  {
    id: 'o2',
    orderNumber: 'ORD-3321',
    customerName: 'Bob Smith',
    address: '456 Oak Ave',
    items: [{ productId: 'p2', quantity: 1 }],
    status: OrderStatus.PENDING,
    requiresCash: false,
    cashAmount: 0,
    requiresETransfer: false,
    eTransferAmount: 0,
    requirePhoto: false, // Optional photo
    createdAt: Date.now(),
  },
  // --- Historical Scenario: Nov 16, 2023 ---
  {
    id: 'h_o1',
    orderNumber: 'ORD-1001',
    customerName: 'TechCorp Office',
    address: '100 Innovation Dr, Suite 200',
    items: [{ productId: 'p1', quantity: 10 }, { productId: 'p4', quantity: 5 }],
    status: OrderStatus.DELIVERED,
    storeId: 'u4',
    requiresCash: true,
    cashAmount: 65.00,
    requiresETransfer: false,
    eTransferAmount: 0,
    createdAt: DATE_NOV_16_START,
    deliveredAt: DATE_NOV_16_DELIVERY_1,
  },
  {
    id: 'h_o2',
    orderNumber: 'ORD-1002',
    customerName: 'Cafe Delight',
    address: '45 Main St',
    items: [{ productId: 'p3', quantity: 4 }],
    status: OrderStatus.DELIVERED,
    storeId: 'u4',
    requiresCash: true,
    cashAmount: 100.00,
    requiresETransfer: false,
    eTransferAmount: 0,
    createdAt: DATE_NOV_16_START,
    deliveredAt: DATE_NOV_16_DELIVERY_2,
  },
  // --- Historical Scenario: Nov 17, 2023 ---
  {
    id: 'h_o3',
    orderNumber: 'ORD-2001',
    customerName: 'Gym Center',
    address: '88 Fitness Blvd',
    items: [{ productId: 'p1', quantity: 20 }],
    status: OrderStatus.DELIVERED,
    storeId: 'u4',
    requiresCash: false, // Paid online
    cashAmount: 0,
    requiresETransfer: false,
    eTransferAmount: 0,
    createdAt: DATE_NOV_17_START,
    deliveredAt: DATE_NOV_17_DELIVERY_1,
  },
  {
    id: 'h_o4',
    orderNumber: 'ORD-2002',
    customerName: 'Private Residence',
    address: '12 Quiet Ln',
    items: [{ productId: 'p2', quantity: 2 }],
    status: OrderStatus.DELIVERED,
    storeId: 'u4',
    requiresCash: true,
    cashAmount: 25.00,
    requiresETransfer: false,
    eTransferAmount: 0,
    createdAt: DATE_NOV_17_START,
    deliveredAt: DATE_NOV_17_DELIVERY_2,
  }
];

export const INITIAL_TRANSACTIONS: StockTransaction[] = [
    // --- Historical Transactions: Nov 16, 2023 ---
    {
        id: 'tx_h1',
        type: TransactionType.ASSIGN_TO_STORE,
        status: TransactionStatus.APPROVED,
        storeId: 'u4',
        items: [{ productId: 'p1', quantity: 20 }, { productId: 'p3', quantity: 5 }, { productId: 'p4', quantity: 10 }],
        timestamp: DATE_NOV_16_START
    },
    {
        id: 'tx_h2', // Cash Turn-in for Nov 16
        type: TransactionType.CASH_TURN_IN,
        status: TransactionStatus.APPROVED,
        storeId: 'u4',
        items: [],
        cashAmount: 165.00, // 65 + 100
        timestamp: DATE_NOV_16_END
    },
    {
        id: 'tx_h3', // Return unused stock Nov 16
        type: TransactionType.RETURN_FROM_STORE,
        status: TransactionStatus.APPROVED,
        storeId: 'u4',
        items: [{ productId: 'p3', quantity: 1 }, { productId: 'p4', quantity: 5 }],
        timestamp: DATE_NOV_16_END
    },

    // --- Historical Transactions: Nov 17, 2023 ---
    {
        id: 'tx_h4',
        type: TransactionType.ASSIGN_TO_STORE,
        status: TransactionStatus.APPROVED,
        storeId: 'u4',
        items: [{ productId: 'p1', quantity: 30 }, { productId: 'p2', quantity: 5 }],
        timestamp: DATE_NOV_17_START
    },
    {
        id: 'tx_h5', // Cash Turn-in for Nov 17
        type: TransactionType.CASH_TURN_IN,
        status: TransactionStatus.APPROVED,
        storeId: 'u4',
        items: [],
        cashAmount: 25.00,
        timestamp: DATE_NOV_17_END
    }
];